// Observable state of the server job currently driving the UI.

import type { JobView } from './api';

export const serverJob = $state({
  active: false,
  kind: '',
  status: '' as JobView['status'] | '',
  progress: 0,
  etaMs: 0,
  queuePosition: 0 as number | undefined,
});

export function trackJob(kind: string) {
  serverJob.active = true;
  serverJob.kind = kind;
  serverJob.status = 'queued';
  serverJob.progress = 0;
  serverJob.etaMs = 0;
  serverJob.queuePosition = undefined;
  return (v: Partial<JobView> & { eta_ms: number }) => {
    if (v.status) serverJob.status = v.status;
    serverJob.progress = v.progress ?? serverJob.progress;
    serverJob.etaMs = v.eta_ms;
    serverJob.queuePosition = v.queue_position;
  };
}

export function endJob() {
  serverJob.active = false;
}
